import React from 'react';
import { Nav, Button } from 'react-bootstrap';
import "bootstrap/dist/css/bootstrap.min.css";

const ALLOW_LOGIN_ONLY = process.env.REACT_APP_ALLOW_LOGIN_ONLY === 'true';

const LoginButton = ({ onClick }) => {
    // Early return to avoid rendering if on login page
    if (window.location.pathname === "/login") {
        return null;
    }

    return (
        <Nav.Link eventKey={2}>
            <Button 
                variant="primary" 
                onClick={onClick}
                style={{ fontSize: 14, fontFamily: "poppins" }}
            >
                {ALLOW_LOGIN_ONLY ? "Login" : "Login/Sign up"}
            </Button>
        </Nav.Link>
    );
};

export default LoginButton;